<template>
	<div class="content-wrapper">
		<div class="content">
			<slot />
		</div>
		<div v-if="$slots['footer']" class="content-footer">
			<slot name="footer" />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";
/**
 * Content wrapper is most common wrapper in slide out. It holds all the content where user interacts the most. Content of a content wrapper changes based on the user’s interaction with options in right column of slide out. When there are multiple columns in a slide-out, content that user sees in the right column is usually wrapped in “Content Wrapper”.
 */
export default defineComponent({
	name: "ContentWrapper"
});
</script>
<style lang="scss">
$border-color: var(--slideout-border-light);

.content-wrapper {
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	border-right: 1px solid $border-color;
	flex: 1;
	position: relative;
	// min-width: 400px;

	.content {
		height: inherit;
		overflow-y: auto;
	}

	.content-footer {
		border-top: 1px solid $border-color;
		min-height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
		// padding: 24px;
		// gap: 24px;

		> * {
			margin: 24px 12px 24px 12px;

			&:first-child {
				margin: 24px 12px 24px 24px;
			}

			&:last-child {
				margin: 24px 24px 24px 12px;
			}
		}

		> :only-child {
			margin: 24px 24px 24px 24px;
		}
	}
}
</style>
